import React, { useEffect, useState } from 'react';
import { DEFAULT_PRODUCT_IMAGE, isMissingProductImage, resolveProductImageUrl } from '../utils/productImage';

function ProductImage({
  src,
  alt = '',
  className = '',
  fallbackSrc = DEFAULT_PRODUCT_IMAGE,
  square = true,
  ...rest
}) {
  const [currentSrc, setCurrentSrc] = useState(() => resolveProductImageUrl(src));
  const [usingFallback, setUsingFallback] = useState(() => isMissingProductImage(src));

  useEffect(() => {
    setCurrentSrc(resolveProductImageUrl(src));
    setUsingFallback(isMissingProductImage(src));
  }, [src]);

  const handleError = () => {
    setCurrentSrc(fallbackSrc);
    setUsingFallback(true);
  };

  const isHoverImage = className.includes('hover-img');
  const isMainDetailImage = className.includes('product-main-image');
  const useSquareFrame = square && !isMainDetailImage;

  const imageClassName = [
    className,
    usingFallback ? 'sk-product-fallback' : '',
  ].filter(Boolean).join(' ');

  const image = (
    <img
      src={currentSrc}
      alt={alt}
      className={imageClassName}
      onError={handleError}
      {...rest}
    />
  );

  if (!useSquareFrame) {
    return image;
  }

  const frameClassName = [
    'sk-product-image-frame',
    isHoverImage ? 'hover-img-frame' : '',
    usingFallback ? 'is-fallback' : '',
  ].filter(Boolean).join(' ');

  return <span className={frameClassName}>{image}</span>;
}

export default ProductImage;
